import * as React from "react"

import { cn } from "../../lib/utils"

// Add custom styles to prevent selection in a more cross-browser compatible way
const noSelectStyle = {
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  userSelect: 'none',
  outline: 'none'
};

const Textarea = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export function TextArea({
  label,
  value,
  onChange,
  placeholder,
  isProcessing = false,
  readOnly = false,
  className,
}) {
  return (
    <div 
      className="relative select-none focus:outline-none" 
      tabIndex="-1"
      style={noSelectStyle}
    >
      {label && (
        <div className="bg-gray-50 dark:bg-gray-800 px-4 py-3 border-b dark:border-gray-700 select-none pointer-events-none">
          <span className="font-medium text-gray-700 dark:text-gray-300">{label}</span>
        </div>
      )}
      <Textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly || isProcessing}
        className={cn(
          "resize-none border-0 focus-visible:ring-0 focus-visible:ring-offset-0 rounded-none p-4 min-h-[200px] md:min-h-[300px] dark:bg-gray-900 dark:text-gray-100 dark:placeholder:text-gray-400 select-text",
          label ? "" : "rounded-t-lg",
          readOnly ? "bg-gray-50 dark:bg-gray-900" : "",
          className,
        )}
      />
    </div>
  )
}

export { Textarea } 